import { keys, map, pick } from 'lodash';

const titles = {
  address: 'Адрес',
  way: 'Способ проезда',
  phone: 'Телефон',
  workingTime: 'Время работы',
};

export default function getContactFields(inspection) {
  const data = pick(inspection, keys(titles));
  return map(titles, (title, field) => {
    return {
      title: title,
      value: data[field] || '—',
    };
  });
}
